import { am } from './utils';

import httpClient from '@/utils/httpClient';
import logger from '@/utils/logger';

export const LOGIN = am('LOGIN');
export const LOGOUT = am('LOGOUT');
export const INITIALIZATION = am('INITIALIZATION');

export const state = {
  isReady: false,
  isRequestPending: false,
  isRequestFailed: false,

  isAuthenticated: false,

  email: null,
  firstName: null,
  lastName: null,

  permissions: null
};

export function decodeJwtToken(token) {
  const [, payload] = token.split('.');
  const { iss, sub, email, firstName, lastName, permissions } = JSON.parse(window.atob(payload));
  return {
    iss,
    sub,
    email,
    firstName,
    lastName,
    permissions
  };
}

const getters = {};

export const actions = {
  async initialize({ commit }) {
    commit(LOGIN.STARTED);

    try {
      let token = localStorage.getItem('HARRITY_AUTH_TOKEN');
      if (token) {
        token = await httpClient.post(`/api/auth/refresh`);
        localStorage.setItem('HARRITY_AUTH_TOKEN', token);

        const { email, firstName, lastName, permissions } = decodeJwtToken(token);
        commit(LOGIN.COMPLETED, { email, firstName, lastName, permissions });
      } else {
        commit(LOGOUT.COMPLETED);
      }
    } catch (e) {
      logger.error(e);
      commit(LOGOUT.COMPLETED);
      throw e;
    } finally {
      commit(INITIALIZATION.COMPLETED);
    }
  },
  async login({ commit }, { email, password }) {
    commit(LOGIN.STARTED);
    try {
      const token = await httpClient.post(`/api/auth/login`, { email, password });
      localStorage.setItem('HARRITY_AUTH_TOKEN', token);

      const { firstName, lastName, permissions } = decodeJwtToken(token);
      commit(LOGIN.COMPLETED, { email, firstName, lastName, permissions });
    } catch (e) {
      commit(LOGIN.FAILED);
      logger.error(e);
      throw e;
    }
  },
  async logout({ commit }) {
    try {
      localStorage.removeItem('HARRITY_AUTH_TOKEN');
      commit(LOGOUT.COMPLETED);
    } catch (e) {
      logger.error(e);
      throw e;
    }
  }
};

export const mutations = {
  [LOGIN.STARTED](state) {
    state.isRequestPending = true;
    state.isRequestFailed = false;
    state.isAuthenticated = false;
    state.email = null;
    state.firstName = null;
    state.lastName = null;
    state.permissions = null;
  },
  [LOGIN.FAILED](state) {
    state.isRequestPending = false;
    state.isRequestFailed = true;
  },
  [LOGIN.COMPLETED](state, { email, firstName, lastName, permissions }) {
    state.isRequestPending = false;
    state.isAuthenticated = true;
    state.email = email;
    state.firstName = firstName;
    state.lastName = lastName;
    state.permissions = permissions;
  },
  [LOGOUT.COMPLETED](state) {
    state.isRequestPending = false;
    state.isAuthenticated = false;
    state.email = null;
    state.firstName = null;
    state.lastName = null;
    state.permissions = null;
  },
  [INITIALIZATION.COMPLETED](state) {
    state.isReady = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
